<template>
  <SogPage title="Recherche">
    <SogFlexRow>
      <div>
        <SogCard>
          <SogCardTitle>Suchkriterien</SogCardTitle>
          <SogCardContent>
            <SogForm>
              <SogFormField>
                <SogTextBox
                  ref="eNumber"
                  v-model="_number"
                  placeholder="Versicherungsnummer"
                  :interval-modified="onSearch"
                />
              </SogFormField>
              <SogFormField>
                <SogTextBox
                  v-model="_kennzeichen"
                  placeholder="Kennzeichen"
                  :interval-modified="onSearch"
                />
              </SogFormField>
              <SogFormField>
                <SogTextBox
                  v-model="_fahrzeugIdentifizierungsnummer"
                  placeholder="FahrzeugIdentifizierungsnummer"
                  :interval-modified="onSearch"
                />
              </SogFormField>
            </SogForm>
          </SogCardContent>
          <SogCardActions>
            <SogCardActionButton
              ref="btnSearch"
              mdi-icon="mdi-magnify"
              @click="onSearch"
            >
              Suchen
            </SogCardActionButton>
          </SogCardActions>
        </SogCard>
      </div>
      <VehicleRegistrationInfo
        v-show="data"
        :data="data"
      />
    </SogFlexRow>

    <SogCard>
      <SogCardTitle>Ergebnis</SogCardTitle>
      <SogCardContent>
        <SogGrid
          ref="_grid"
          :url="_url"
          :columns="_columns"
          :on-row-selected="onRowSelected"
          :on-row-deselected="onRowDeselected"
        />
      </SogCardContent>
    </SogCard>
  </SogPage>
</template>

<script setup lang="ts">
import SogPage from "@/shared/ui/SogPage.vue";
import SogCard from "@/shared/ui/SogCard.vue";
import SogCardTitle from "@/shared/ui/SogCardTitle.vue";
import SogCardContent from "@/shared/ui/SogCardContent.vue";
import SogForm from "@/shared/ui/SogForm.vue";
import SogFormField from "@/shared/ui/SogFormField.vue";
import SogTextBox from "@/shared/ui/SogTextBox.vue";
import SogCardActions from "@/shared/ui/SogCardActions.vue";
import { onMounted, ref } from "vue";
import { ColumnModel } from "@syncfusion/ej2-grids/src/grid/models/column";
import { DateColumn, DateTimeColumn, DefaultColumn } from "@/shared/ui/types/SogGridColumnDefinitions";
import SogGrid from "@/shared/ui/SogGrid.vue";
import { RowSelectEventArgs } from "@syncfusion/ej2-vue-grids";
import DtoSearch from "@/shared/model/DtoSearch";
import VehicleRegistrationInfo from "@/modules/VehicleRegistration/components/VehicleRegistrationInfo.vue";
import SogFlexRow from "@/shared/ui/SogFlexRow.vue";
import { Api } from "@/shared/services/api";
import SogCardActionButton from "@/shared/ui/SogCardActionButton.vue";

const eNumber = ref<InstanceType<typeof SogTextBox>  | null>(null)
const _number = ref("");
const _kennzeichen = ref("");
const _fahrzeugIdentifizierungsnummer = ref("");

const _grid = ref<InstanceType<typeof SogGrid>  | null>(null)

const _url = Api.baseUrl+'/Search';

const _columns: ColumnModel[] = [
  /*
  { type: 'checkbox' },
*/
  { ...DefaultColumn, field: 'insuranceId', headerText: 'Insurance Id', isPrimaryKey: true ,visible:false},
  { ...DefaultColumn, field: 'vehicleRegistrationId', headerText: 'VehicleRegistrationId',visible:false},
  { ...DefaultColumn, field: 'insuranceNumber', headerText: 'Versicherungsnummer', filter: { type: 'CheckBox' } },
  { ...DefaultColumn, field: 'evb', headerText: 'eVb' },
  { ...DefaultColumn, field: 'kennzeichen', headerText: 'Kennzeichen' },
  { ...DateTimeColumn, field: 'datumVersicherungsBeginn', headerText: 'Versicherungsbeginn' },
  { ...DateColumn, field: 'kennzeichenDatumGueltigBis', headerText: 'Versicherungsende' },
  { ...DefaultColumn, field: 'fahrzeugIdentifizierungsNummer', headerText: 'FahrzeugIdentifizierungsnummer' },

]


onMounted(()=>{
  eNumber.value?.focus()
})

function onSearch(){
  _grid.value?.adaptor.removePredicate("number");
  if(_number.value)
    _grid.value?.adaptor.addPredicate("number","contains",_number.value.toUpperCase());

  _grid.value?.adaptor.removePredicate("kennzeichen");
  if(_kennzeichen.value)
    _grid.value?.adaptor.addPredicate("kennzeichen","contains",_kennzeichen.value.toUpperCase());

  _grid.value?.adaptor.removePredicate("fahrzeugIdentifizierungsNummer");
  if(_fahrzeugIdentifizierungsnummer.value)
    _grid.value?.adaptor.addPredicate("fahrzeugIdentifizierungsNummer","contains",_fahrzeugIdentifizierungsnummer.value.toUpperCase());

  _grid.value?.refresh();
}

const data = ref<DtoSearch>();

function onRowSelected(args:any){
  const a = args as RowSelectEventArgs;
  data.value = a.data as DtoSearch;
}

function onRowDeselected(args:any){
  if(!args.isInteracted)
    return
  data.value = undefined;
}


</script>
<style scoped>
</style>
